import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollTopButton from "@/components/feature/ScrollTopButton";
import HeroSection from "./components/HeroSection";
import ComicSections from "./components/ComicSections";
import CategorySection from "./components/CategorySection";
import InfoSections from "./components/InfoSections";

const faqLd = [
  {
    q: "天天漫画网多久更新一次漫画？",
    a: "网站每日更新，热门连载漫画的最新话会在每日上午陆续同步上线，最晚当天晚间更新完毕。进入『今日更新』板块即可查看当天所有新增章节。",
  },
  {
    q: "如何快速找到想看的漫画？",
    a: "你可以在顶部搜索框直接输入漫画名称，也可以进入『漫库』页面，按分类（热血冒险、奇幻仙侠、都市生活等）筛选，或按热度、评分排序浏览。",
  },
  {
    q: "连载中的漫画会不会突然断更？",
    a: "我们会对连载作品持续跟进，若某部作品进入休刊或停更，会在作品详情页标注当前状态，方便你及时了解追更进度，避免长时间等待。",
  },
  {
    q: "漫画内容适合所有年龄段的读者吗？",
    a: "天天漫画网收录了覆盖多种题材的连载作品，从校园青春到悬疑推理应有尽有。建议家长和读者根据作品详情页的题材与标签，选择适合自己阅读的内容。",
  },
];

const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "天天漫画网",
  url: "https://panelplay1.github.io/",
  description:
    "天天漫画网每日更新热门连载漫画，追更漫画不迷路，今日更新最新话同步上线。",
  inLanguage: "zh-CN",
};

const orgLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "天天漫画网",
  url: "https://panelplay1.github.io/",
  description: "每日更新连载漫画的内容平台，追更漫画不迷路。",
};

const faqLdJson = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqLd.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function HomePage() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLdJson) }} />
      <Navbar />
      <main>
        <HeroSection />
        <ComicSections />
        <CategorySection />
        <InfoSections />
      </main>
      <Footer />
      <ScrollTopButton />
    </>
  );
}